export default "__VITE_ASSET__CO93G9fz__"